import React from 'react';
import Breadcrumbs from '@component/Breadcrumbs';

const BreadCrumbComponent = (props) => {
  const previousLinks = [];
  const ancestorsItems = props?.fields?.ancestors;
  ancestorsItems?.map((link, i) => {
    previousLinks.push(
      `<a href=${link?.url} key={i}>
      ${link.text}
    </a>`
    );
  });

  if (!props?.fields?.currentpage?.hideshownav) {
    return (
      <div className="breadcrumb-container">
        <Breadcrumbs previouslinks={previousLinks} currentlink={props?.fields?.currentpage?.text} />
      </div>
    );
  }
  return <div className="breadcrumb-container no-breadcrumb"></div>;
};
export default BreadCrumbComponent;
